"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../styles/NotesStyle");
var Localize_1 = require("../../gen-src/Localize");
var widgets_1 = require("@tableau/widgets");
var NotesTestId = 'notes';
exports.NotesTestId = NotesTestId;
var Notes = /** @class */ (function (_super) {
    __extends(Notes, _super);
    function Notes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleBlur = function () {
            // TextArea has lost focus, so hasFocus is false
            _this.props.onFocusChange(false);
        };
        _this.handleFocus = function () {
            // TextArea has gained focus, so hasFocus is true
            _this.props.onFocusChange(true);
        };
        return _this;
    }
    Notes.prototype.render = function () {
        return (React.createElement("div", { style: styles.notesContainer },
            React.createElement(widgets_1.TextAreaWidget, { label: Localize_1.Messages.sharingMessageLabel(), maxLength: 1000, onBlur: this.handleBlur, onFocus: this.handleFocus, onInput: this.props.onNotesChange, style: styles.notesInput, testId: NotesTestId })));
    };
    return Notes;
}(React.PureComponent));
exports.Notes = Notes;
//# sourceMappingURL=Notes.js.map